import React, { useEffect } from 'react';
import { Box, Card, Grid, Icon, IconButton, styled, Tooltip } from '@mui/material';
import {
  apiGetSumConsumptionByDay,
  apiGetSumConsumptionByMonth
} from '@services/ManageCustomers/CustomerServices';
import moment from 'moment';
import Loading from '@components/Loading';
import { showError } from '@components/notification';
import { formatCurrency, isNullOrEmpty } from '@utils/utils';

// KPI-style stat tile (matches the dashboard KPI strip)
const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 18px !important',
  borderRadius: '14px !important',
  background: 'var(--surface)',
  border: '1px solid var(--border)',
  boxShadow: 'var(--shadow-sm) !important',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    borderColor: 'var(--border-strong)',
    boxShadow: 'var(--shadow-md) !important'
  },
  [theme.breakpoints.down('sm')]: { padding: '14px !important' }
}));

const TONES = {
  water_drop: ['#0284c7', 'var(--primary-soft)'],
  verified_user: ['#059669', 'color-mix(in srgb, #059669 12%, transparent)'],
  remove_moderator: ['#ea580c', 'color-mix(in srgb, #ea580c 12%, transparent)']
};
const toneStyle = (icon) => TONES[icon] && { color: TONES[icon][0], background: TONES[icon][1] };

const ContentBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  '& .icon': {
    width: 44,
    height: 44,
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    fontSize: 22,
    color: '#0284c7',
    background: 'var(--primary-soft)'
  }
}));

const Heading = styled('h6')(() => ({
  margin: 0,
  fontSize: '13px',
  fontWeight: 500,
  color: 'var(--muted)'
}));
const TextValue = styled('h6')(() => ({
  margin: 0,
  marginTop: '4px',
  fontFamily: 'var(--font-mono, ui-monospace, Menlo, Consolas, monospace)',
  fontSize: '22px',
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: 'var(--text)'
}));

const ConsumptionCard = ({
  rangeDateString,
  dataFilterAdvance,
  flagSearch,
  keyWord,
  serialNo,
  sumConsumption,
  loadingFetch
}) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiGetSumConsumptionByDay({
        keyWord: keyWord ?? undefined,
        serialNo: serialNo,
        community: 'HP',
        fromDate: rangeDateString?.length ? rangeDateString[0] : undefined,
        toDate: rangeDateString?.length ? rangeDateString[0] : undefined,
        ...dataFilterAdvance
      });
      setData(response?.data?.data);
    } catch (error) {
      setData([]);
      showError('Lỗi khi tính dữ liệu tiêu thụ theo tháng');
      console.error('Error fetching consumption data:', error);
    } finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   fetchData();
  // }, [flagSearch]);
  const cardList = [
    {
      name: 'Tổng tiêu thụ (m3)',
      total: !isNullOrEmpty(sumConsumption) ? formatCurrency(sumConsumption, 3) : 'N/A',
      icon: 'water_drop'
    }
    // {
    //   name: 'Số lượng KH đủ dữ liệu tính',
    //   total: !isNullOrEmpty(data?.total_customers_with_consumption)
    //     ? data?.total_customers_with_consumption
    //     : 'N/A',
    //   icon: 'verified_user'
    // },
    // {
    //   name: 'Tổng số lượng KH',
    //   total: !isNullOrEmpty(data?.total_records) ? data?.total_records : 'N/A',
    //   icon: 'verified_user'
    // }
  ];

  return (
    <Grid container spacing={3}>
      {cardList.map((item, index) => (
        <Grid item xs={12} md={4} key={index}>
          <StyledCard elevation={0} loading={loading}>
            <ContentBox>
              <Icon className="icon" style={toneStyle(item.icon)}>
                {item.icon}
              </Icon>
              <Box ml="14px" minWidth={0}>
                <Heading sty>{item.name}</Heading>
                <TextValue>{loadingFetch ? <Loading /> : item?.total}</TextValue>
              </Box>
            </ContentBox>
          </StyledCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default ConsumptionCard;
